import { ImageGalleryProivderState } from "./ImageGalleryProivder.types";
import { createContext } from "react";

export const ImageGalleryProivderContext = createContext<ImageGalleryProivderState | undefined>(undefined);